import React from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { componentKey, setRecipientAddressInformation } from '../../AddRecipientSlice';
import { componentKey as dataLoaderComponentKey } from '../../../../loaders/dataloader/DataLoaderSlice';
import { generalValidator } from '../../../../../../libs/utility/validators/GeneralValidator';
import commonStyles from "../../AddRecipient.styles"
import Heading from '../../../../../components/heading/Heading';
import { HEADING } from '../../../../../components/heading/constants/constants';
import TextInput from '../../../../../components/input/textinput/TextInput';
import SelectDropdown from '../../../../../components/dropdown/selectdropdown/SelectDropdown';
import styles from "./GetAddressInfo.styles"
import { validateZipCode } from '../../AddRecipientSaga';
import General from '../../../../../../libs/utility/General';
import { RECIPIENT_TYPE_TITLE } from '../../getrecipienttype/constants';
import Loadable from '../../../../../components/loadable/Loadable';
import { ADD_RECIPIENT_LOADING_STATES, ADD_RECIPIENT_MESSAGE_MAP } from '../../constant';

export default function GetAddressInfo({renderForSingleView = false}) {

    const { countriesList, statesList } = useSelector(state => state[dataLoaderComponentKey])

    const { loadingState, recipientAddressInformation, recipientBasicInfo, RequestType, RecipientType } = useSelector((state) => state[componentKey]);

    const dispatch = useDispatch();

    const onChangehandler = (event, rules) => {
        const { name, value } = event.target;

        if (rules) {
            const errors = generalValidator.validate(value, rules);
            dispatch(setRecipientAddressInformation({ [name]: { value, errors, rules } }));
        } else {
            dispatch(setRecipientAddressInformation({ [name]: { value } }));
        }
    };

    const recipientName = RecipientType === RECIPIENT_TYPE_TITLE.INDIVIDUAL ? recipientBasicInfo?.RecipientFirstName?.value : recipientBasicInfo?.RecipientLastName?.value;
    const zipCode = General.formatZipCode(recipientAddressInformation.RecipientZIP?.value)

    return (
        <>
            <div style={commonStyles.container}>
                <div>
                    <Heading type={HEADING.H1}>{`What is ${General.formatNameAsPossessive(recipientName)} address?`}</Heading>
                    <p>You can use our USPS mailing feature to share reports with {recipientName} to this address.</p>
                </div>

                <div style={commonStyles.formContainer}>
                    <div style={styles.formRow}>
                        <div style={styles.recipientsFieldsContainer}>
                            <div style={styles.recipientBatch1Container}>
                                <TextInput
                                    name="RecipientAddress"
                                    label="Street Address (including apartment number)"
                                    placeHolder='Enter street address'
                                    value={recipientAddressInformation.RecipientAddress?.value}
                                    onChangeCb={onChangehandler}
                                    rules={recipientAddressInformation.RecipientAddress?.rules}
                                    errors={recipientAddressInformation.RecipientAddress?.errors}
                                    formSubmitted={recipientAddressInformation.allRequiredFieldsTouched}
                                />
                            </div>
                            <div style={styles.recipientBatch2Container}>
                                <TextInput
                                    name="RecipientAddress2"
                                    label="Address line 2"
                                    placeHolder='Enter address'
                                    value={recipientAddressInformation.RecipientAddress2?.value}
                                    onChangeCb={onChangehandler}
                                />
                            </div>
                        </div>
                    </div>
                    <div style={styles.formRow}>
                        <div style={styles.fieldContainer}>
                            <SelectDropdown
                                label="Country"
                                placeHolder="Enter country"
                                name="RecipientCountry"
                                value={{ label: recipientAddressInformation.RecipientCountry.label, value: recipientAddressInformation.RecipientCountry.value }}
                                onSelectCb={(name, selectedOption) => dispatch(setRecipientAddressInformation({ [name]: selectedOption }))}
                                options={countriesList}
                                rules={recipientAddressInformation.RecipientCountry?.rules}
                                errors={recipientAddressInformation.RecipientCountry?.errors}
                                formSubmitted={recipientAddressInformation.allRequiredFieldsTouched}
                            />
                        </div>
                        <div style={styles.fieldContainer}>
                            {recipientAddressInformation.RecipientCountry.value === "US" ?
                                <SelectDropdown
                                    label="State"
                                    placeHolder="Enter state"
                                    name="RecipientState"
                                    value={recipientAddressInformation.RecipientState}
                                    onSelectCb={(name, selectedOption) => dispatch(setRecipientAddressInformation({ [name]: selectedOption }))}
                                    options={statesList}
                                    rules={recipientAddressInformation.RecipientState?.rules}
                                    errors={recipientAddressInformation.RecipientState?.errors}
                                    formSubmitted={recipientAddressInformation.allRequiredFieldsTouched}
                                />

                                :

                                <TextInput
                                    label="State"
                                    placeHolder='Enter state name'
                                    name="RecipientState"
                                    value={recipientAddressInformation.RecipientState.label}
                                    onChangeCb={(e) => dispatch(setRecipientAddressInformation({ [e.target.name]: { label: e.target.value, value: e.target.value } }))}
                                    rules={recipientAddressInformation.RecipientState?.rules}
                                    errors={recipientAddressInformation.RecipientState?.errors}
                                    formSubmitted={recipientAddressInformation.allRequiredFieldsTouched}
                                />}
                        </div>
                    </div>

                    <div style={styles.formRow}>
                        <div style={styles.fieldContainer}>
                            <Loadable currentState={loadingState.state} loadingStates={[ADD_RECIPIENT_LOADING_STATES.VALIDATE_ZIP_CODE_LOADING]} messageMap={ADD_RECIPIENT_MESSAGE_MAP} isNewLoadable={true}>
                                <TextInput
                                    name="RecipientZIP"
                                    label="ZIP code"
                                    placeHolder='Enter Zip Code'
                                    value={zipCode}
                                    onChangeCb={onChangehandler}
                                    onBlurCb={() => dispatch(validateZipCode(recipientAddressInformation))}
                                    rules={recipientAddressInformation.RecipientZIP?.rules}
                                    errors={recipientAddressInformation.RecipientZIP?.errors}
                                    formSubmitted={recipientAddressInformation.allRequiredFieldsTouched}
                                />
                            </Loadable>
                        </div>
                        <div style={styles.fieldContainer}>
                            <TextInput
                                name="RecipientCity"
                                label="City"
                                placeHolder='Enter city name'
                                value={recipientAddressInformation.RecipientCity?.value}
                                onChangeCb={onChangehandler}
                                rules={recipientAddressInformation.RecipientCity?.rules}
                                errors={recipientAddressInformation.RecipientCity?.errors}
                                formSubmitted={recipientAddressInformation.allRequiredFieldsTouched}
                            />
                        </div>
                    </div>

                </div>
            </div >
        </>
    )
}
